module.exports = __webpack_public_path__ + "static/media/ic_paboi.a6b76093.png";